// extracted by mini-css-extract-plugin
module.exports = {"root":"ScrollButton_root__1POx7","background":"ScrollButton_background__22sDN","caption":"ScrollButton_caption__AVxZ1"};
    if(module.hot) {
      // 1586964020105
      var cssReload = require("!../../../../node_modules/css-hot-loader/hotModuleReplacement.js")(module.id, {"fileMap":"{fileName}"});
      module.hot.dispose(cssReload);
      module.hot.accept(undefined, cssReload);;
    }
  